import {TypeLocalNameEnum} from "domain/usecases";
import {TELEMEDICINE_INFO} from "presentation/modules/booking/shared/constants/telemedicineInfo";
import {GetTelehealthMostRecentDateStaticParams} from "./types";

const staticParams: GetTelehealthMostRecentDateStaticParams = {
  clinic_code: TELEMEDICINE_INFO.code,
  cityName: 'FORTALEZA',
  stateCode: 'CE',
  typeLocalName: TypeLocalNameEnum.CIDADE,
}

export {
  staticParams,
}
